import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/i18n/i18n';
import '@/styles/globals.css';
import '@/styles/rtl.css';

import { App } from '@/App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html contains <div id="root"></div>.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
